<template>
  <div class="dashboard">
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <div class="dashboardLists">
            <div class="dashboardLists-title">
              <div class="left-title">
								<span class="left-title-box"> </span>
                {{ table1Title }}
              </div>
              <div class="right-title">
                <ul class="date-type">
                  <li
                    v-for="(item, index) of dateTypeLists"
                    :key="index"
                    :class="{ dateActive: index == dateValue1 }"
                    @click="dateTypeClick1(index)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div class="dashbardLists-line"></div>
              <!-- <div id="myChart" :style="{ width: '100%', height: '310px' }"></div> -->
              <el-row
                :style="{ width: '100%', height: '310px' }"
                style="padding: 8px "
              >
                <el-col :span="12" v-for="(item,index) in table1" :key="index">
                  <rate-card :data="item" :style="{'background':rateClass[index].background}" ></rate-card>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12"
        ><div class="grid-content bg-purple">
          <div class="dashboardLists">
            <div class="dashboardLists-title">
              <div class="left-title">
								<span class="left-title-box"> </span>
                {{ table2Title }}
              </div>
              <div class="right-title">
                <ul class="date-type">
                  <li
                    v-for="(item, index) of dateTypeLists"
                    :key="index"
                    :class="{ dateActive: index == dateValue2 }"
                    @click="dateTypeClick2(index)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="dashbardLists-line"></div>
            <div id="myChart" :style="{ width: '100%', height: '310px' }"></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12"
        ><div class="grid-content bg-purple">
          <div class="dashboardLists">
            <div class="dashboardLists-title">
              <div class="left-title">
								<span class="left-title-box"> </span>
                {{ table3Title }}
              </div>
              <div class="right-title">
                <ul class="date-type">
                  <li
                    v-for="(item, index) of dateTypeLists"
                    :key="index"
                    :class="{ dateActive: index == dateValue3 }"
                    @click="dateTypeClick3(index)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="dashbardLists-line"></div>
            <div
              id="myChart2"
              :style="{ width: '99%', height: '310px' }"
            ></div>
          </div></div
      ></el-col>
      <el-col :span="12"
        ><div class="grid-content bg-purple">
          <div class="dashboardLists">
            <div class="dashboardLists-title">
              <div class="left-title">
								<span class="left-title-box"> </span>
                {{ table4Title }}
              </div>
              <div class="right-title">
                <ul class="date-type">
                  <li
                    v-for="(item, index) of dateTypeLists"
                    :key="index"
                    :class="{ dateActive: index == dateValue4 }"
                    @click="dateTypeClick4(index)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="dashbardLists-line"></div>
            <div
              id="myChart3"
              :style="{ width: '99%', height: '310px' }"
            ></div>
          </div></div
      ></el-col>
    </el-row>

    <!-- <ul class="dashboardList"></ul> -->
  </div>
</template>

<style scoped>

.bg-purple {
  /* background: #d3dce6; */
  margin: 10px 0;
  border: 2px solid var(--themeColor);
    border-radius: 4px;
  }
  
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  
  
  .dashboard {
    overflow: auto;
    /* height: 100%;*/
    padding: 15px;
    background: #fff;
  }
  
  .dashboardList .dashboardLists {
    width: 47.5%;
    height: 380px;
    border: 2px solid var(--themeColor);
    float: left;
    margin-right: 25px;
    margin-bottom: 25px;
    /* margin: 15px; */
    overflow: hidden;
    border-radius: 3px;
    /* min-width: 660px; */
  }
  
  .dashboardList .dashboardLists:hover {
    border: 2px solid var(--themeColor);
  }
  
  .dashboardLists-title {
    width: 100%;
    font-size: 16px;
    color: rgb(0, 0, 0);
    overflow: hidden;
    white-space: nowrap;
    /* margin-top: 10px; */
    padding: 12px 0;
    line-height: 28px;
    height: 28px;
  }
  
  .dashbardLists-line {
    margin: -4px 8px 0 8px;
    border: 1px solid #ebf0f4;
  }
  
  .left-title {
    /* border-left: 9px solid  var(--themeColor); */
    width: 48%;
    float: left;
    color: #272727;
    overflow: hidden;
    white-space: nowrap;
    /*规定文本不进行换行*/
    text-overflow: ellipsis;
    /* padding-left: 8px ;
        	margin-left:10px ; */
  }
  
  .left-title-box {
    border-left: 8px solid var(--themeColor);
    margin: 0 10px 0 13px;
  }
  
  .right-title {
    /* width: 26%; */
    float: right;
    margin-right: 15px;
    text-align: right;
    /* height: 12%; */
    margin-bottom: 0px;
  
  }
  
  .date-type {
    /* border: 1px solid #fff; */
    overflow: hidden;
    /* width: 220px; */
    margin: 0;
    padding: 0;
    /* margin-left: 20px;
    margin-left: 184px; */
    /* width: 45%; */
  }
  
  .date-type li {
    right: 0;
    float: left;
    font-size: 14px;
    color: #898989;
    /* width: 25%; */
    text-align: center;
    padding: 6px;
  }
  
  .date-type li:hover {
    cursor: pointer;
  }
  
  .dateActive {
    padding-bottom: 6px;
    border-bottom: 3px solid var(--themeColor);
    color: var(--themeColor) !important;
  font-weight: bold;
}

.dateCompare {
  margin: 0;
  padding: 0;
  margin-top: 8px;
}

.dateCompare li {
  float: left;
  width: 42%;
  height: 125px;
  overflow: hidden;
  background: url();
  margin-left: 38px;
  margin-bottom: 15px;
  padding: 0.1rem 0.1rem 0.1rem 0.1rem;
  border-radius: 6px;
  margin-top: 5px;
}
</style>

<script>
import * as echarts from "echarts";
import rateCard from "./rateCard.vue";
export default {
  data() {
    return {
      dateValue1: 3, //第一个图的默认时间，3是季度
      dateTypeLists: [
        {
          name:  this.$t("message.calendar.day"),
          value: 1,
        },
        {
          name:  this.$t("message.calendar.week"),
          value: 2,
        },
        {
          name:  this.$t("message.calendar.month"),
          value: 3,
        },
        {
          name:  this.$t("message.calendar.season"),
          value: 4,
        },
      ],
      table1Title: "",
      table1: [],

      dateValue2: 3, //第二个图的默认时间，3是季度
      table2Title: "",

      dateValue3: 3, //第三个图的默认时间，3是季度
      table3Title: "",

      dateValue4: 3, //第四个图的默认时间，3是季度
      table4Title: "",

      rateClass: [
        {
          background:' -webkit-linear-gradient(left, #5671fc, #c97dfe)',
        },
        {
          background: '-webkit-linear-gradient(left, #38a8f6, #767cfc)',
        },
        {
          background: '-webkit-linear-gradient(left, #e95e74, #f09f61)',
        },
        {
          background: '-webkit-linear-gradient(left, #48d898, #9ee04e)',
        },
      ],
    };
  },
  components: { rateCard },
  mounted() {
    this.loadTable2();
    this.loadTable3();
    this.loadTable4();
  },
  methods: {
    myChartClick(params) {
      console.log(params);
      let t = {
        title: this.$t("message.title.search"),
        name: this.$t("message.title.search"),
        path: "/dashboardShow",
        content: "/dashboardShow",
      };
      let obj = {
        classId: params.data.classId,
        dateType: this.dateValue2 + 1,
        tableId: 1,
      };
      this.$store.commit("setChangeChartsDetail", obj);
      this.$router.push(t.path);
    },
    myChartClick2(params) {
      let t = {
        title: this.$t("message.title.search"),
        name: this.$t("message.title.search"),
        path: "/dashboardShow",
        content: "/dashboardShow",
      };
      let obj = {
        subClassId: params.data.subClassId,
        dateType: this.dateValue3 + 1,
        tableId: 2,
      };
      this.$store.commit("setChangeChartsDetail", obj);
      this.$router.push(t.path);
    },
    myChartClick3(params) {
      console.log(params);
      let t = {
        title: this.$t("message.title.search"),
        name: this.$t("message.title.search"),
        path: "/dashboardShow",
        content: "/dashboardShow",
      };
      let obj = {
        subClassId: params.data[5],
        dateType: this.dateValue3 + 1,
        tableId: 2,
      };
      this.$store.commit("setChangeChartsDetail", obj);
      this.$router.push(t.path);
    },
    dateTypeClick1(i) {
      this.dateValue1 = i;
      this.loadTable(i + 1);
    },
    dateTypeClick2(i) {
      this.dateValue2 = i;
      this.loadTable2(i + 1);
    },
    dateTypeClick3(i) {
      this.dateValue3 = i;
      this.loadTable3(i + 1);
    },
    dateTypeClick4(i) {
      this.dateValue4 = i;
      this.loadTable4(i + 1);
    },

    async loadTable(e) {
      var dateType = 4; //默认打开季度
      this.table1 = [];
      if (e) {
        dateType = e;
      }
      const { data: res } = await this.$http.get(
        "/pmdm/dashboard/queryDataCompare?dateType=" + dateType
      );
      //console.log(res);
      if (res.code !== 200) return this.$message.error(res.message);
      var tableData = res.object.data;
      this.table1Title = res.object.title.text;
      for (var i = 0; i < tableData.length; i++) {
        var obj = {};
        obj.compare = tableData[i].compare;
        obj.name = tableData[i].name;
        obj.rate = tableData[i].rate;
        obj.rateName = tableData[i].rateName;
        obj.value = tableData[i].value;
        this.table1.push(obj);
      }
    },
    async loadTable2(e) {
      var chartDom = document.getElementById("myChart");
      var myChart = echarts.init(chartDom);
      var option;

      var dateType = 4; //默认打开季度
      if (e) {
        dateType = e;
      }
      const { data: res } = await this.$http.get(
        "/pmdm/dashboard/queryChangeCharts?dateType=" + dateType
      );
      //console.log(res);
      if (res.code !== 200) return this.$message.error(res.message);
      this.table2Title = res.object.title.text;

      option = {
        // title: {
        // 	left: 'right',
        // 	textStyle: {color: '#000'}
        // },
        //鼠标接触触发
        tooltip: {
          trigger: "item",
        },
        //图例组件
        legend: {
          orient: "vertical",
          left: "40px",
          top: "40%",
          itemGap: 20,
        },
        series: [
          {
            type: "pie",
            pieRdius: "50%",
            data: res.object.data,
            showEmptyCircle: true,
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,

            label: {
              color: "#333",
              piePosition: "inside",
              fontSize: 16,
              show: true,
              formatter: "{b} : {d}%",
            },
            labelLine: { show: false },
            emphasis: {
              scale: true,
              scaleSize: 2,
            },
            avoidLabelOverlap: true,
            itemStyle: {
              pieBorderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
              color: function(params) {
                var colorList = [
                  {
                    c1: " #767cfc", //ECO
                    c2: "#38a8f6",
                  },
                  {
                    c1: " #ff6a6a", //MCO
                    c2: "#ffba00",
                  },
                  {
                    c1: "#20bb01", //ECR
                    c2: "#46f093",
                  },
                ];
                return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上

                    offset: 0,
                    color: colorList[params.dataIndex].c2,
                  },
                  {
                    offset: 1,
                    color: colorList[params.dataIndex].c1,
                  },
                ]);
                /*  return colorList[params.dataIndex]*/
              },
            },
            left: "10%",
          },
        ],
      };

      option && myChart.setOption(option);

      myChart.on("click", this.myChartClick);
      //让屏幕自适应
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    async loadTable3(e) {
      var chartDom = document.getElementById("myChart2");
      var myChart = echarts.init(chartDom);
      var option;

      var dateType = 4; //默认打开季度
      if (e) {
        dateType = e;
      }
      const { data: res } = await this.$http.get(
        "/pmdm/dashboard/queryEcoChangeCharts?dateType=" + dateType
      );
      console.log(res);
      if (res.code !== 200) return this.$message.error(res.message);
      this.table3Title = res.object.title.text;
      let EcoName = [];
      let EcoVal = [];
      let EcoData = res.object.data;
      for (var i = 0; i < EcoData.length; i++) {
        let EcoSubCls = {};
        EcoName.push(EcoData[i].name);
        EcoSubCls.value = EcoData[i].value;
        EcoSubCls.subClassId = EcoData[i].subClassId;
        EcoVal.push(EcoSubCls);
      }

      option = {
        backgroundColor: "#fff",
        title: {
          text: "",
          subtext: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: { show: false },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: { show: false },
        yAxis: {
          type: "category",
          data: EcoName,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#000" },
        },
        series: [
          {
            name: res.object.title.subtext,
            type: "bar",
            data: EcoVal,
            itemStyle: {
              barBorderRadius: 20,
            },
            barWidth: "45%",
            showBackground: true,
            label: {
              show: true,
              position: "right",
              color: "var(--themeColor)",
              fontSize: 16,
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                {
                  offset: 0,
                  color: "#2771ea", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#01d1ff", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
        ],
      };

      option && myChart.setOption(option);

      myChart.on("click", this.myChartClick2);
      //让屏幕自适应
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    async loadTable4(e) {
      var chartDom = document.getElementById("myChart3");
      var myChart = echarts.init(chartDom);
      var option;

      var dateType = 4; //默认打开季度
      if (e) {
        dateType = e;
      }
      const { data: res } = await this.$http.get(
        "/pmdm/dashboard/queryChangeBubble?dateType=" + dateType
      );
      console.log(res);
      if (res.code !== 200) return this.$message.error(res.message);
      this.table4Title = res.object.title.text;
      let changeAllVal = [];
      let changeData = res.object.data;
      for (var i = 0; i < changeData.length; i++) {
        let changeVal = [];
        changeVal.push(changeData[i].xvalue);
        changeVal.push(Number(changeData[i].yvalue));
        changeVal.push(changeData[i].sum);
        changeVal.push(changeData[i].name);
        changeVal.push(changeData[i].titleName);
        changeVal.push(changeData[i].subClassId);
        changeAllVal.push(changeVal);
      }
      console.log(changeAllVal);
      // var data = [
      // 	[[3,8,123321,'Australia',"变更"],[2,7,3121233,'Canada',"变更"],[34,3,9999,'China',"变更"]]
      // ];
      option = {
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: "#2771ea", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#01d1ff", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
        backgroundColor: "#fff",
        title: {
          text: "",
          left: "5%",
          top: "3%",
        },
        legend: {
          right: "10%",
          top: "3%",
          data: ["变更"],
        },
        grid: {
          left: "8%",
          top: "10%",
        },
        legend: { show: false },
        xAxis: {
          axisLine: { show: false },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#ffba00",
            },
          },
        },
        yAxis: {
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#ffba00",
            },
          },
          scale: true,
        },
        series: [
          {
            name: "变更",
            data: changeAllVal,
            type: "scatter",
            symbolSize: function(data) {
              return Math.sqrt(data[2]) * 2;
            },
            emphasis: {
              focus: "series",
              label: {
                show: true,
                formatter: function(param) {
                  return param.data[3];
                },
                position: "top",
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(120, 36, 50, 0.5)",
              shadowOffsetY: 5,
              color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                {
                  offset: 0,
                  color: "#ffba00",
                },
                {
                  offset: 1,
                  color: "#ff6a6a",
                },
              ]),
            },
          },
        ],
      };

      option && myChart.setOption(option);
      myChart.on("click", this.myChartClick3);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
  },
  created() {
    this.loadTable();
  },
};
</script>
